module.exports = __webpack_public_path__ + "static/SectionOne-12e2ab85fa774effd43ab52a059be224.png";